.carrier-logo {
  width: 16px;
  height: 16px;
}

.package-dropdown {
  > div {
    width: 100%;
  }
}
